export default {
  hints: {
    recover: 'Forgot your password?'
  },

  buttons: {
    reset: 'Reset',
    request: 'Request'
  }
}
